import { dateFormat, decryptedValue, downloadDocument } from "common/utility";
import CommonDialog from "components/Common/CommonDialog";
import DeleteModal from "components/Common/DeleteModal";
import TableContainerV1 from "components/Common/TableContainerV1";
import ToastDialog from "components/Common/ToastDialog";
import API_SERVICES from "constants/app.constants";
import { useFormik } from "formik";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import {
  callGSTDeleteRecord,
  callGSTINUserCredinatialsSubmit,
  callGSTINUserOTPSubmit,
  callGSTINUserOTPValidSubmit,
  callGSTLists,
} from "http/fundLync/entityDocuments.helper";
import { startCase } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import {
  Col,
  Form,
  FormFeedback,
  Input,
  Label
} from "reactstrap";
import * as Yup from "yup";


const TableActionsComponent = (deleteClickFn) =>{

  
  return (
    <div style={{ display: "flex", gap: "10px" }}>
     <i
              className="mdi  mdi-trash-can-outline action-icon"
              title="Delete"
              onKeyUp={()=>{}}
              onClick={() => {
                deleteClickFn()
              }}
            ></i>
  </div>
  )
}


const TableFileComponent = (value,isPendingFile,fileDownloadFn) =>{
  if(value && !isPendingFile) {
    return <i className="mdi mdi-file-download-outline action-icon" onClick={fileDownloadFn} onKeyUp={()=>{}}></i> 
  }else if(isPendingFile){
    return <span>Pending</span>
  }else
  {
    return <></>
  } 
}


const GSTDocuments = (props) => {
  const urlParams = new URLSearchParams(window.location.search);
  // const encodedId = urlParams.get("id");
  // const entityId = atob(encodedId);
  const [entityId, setEntityId] = useState('')
  const [encodedId, setEncodedId] = useState('')
  document.title = `GST Documnets | FundLync`;
  const [gstSelectedGroup, setGstSelectedGroup] = useState(null);
  const [showCommonDialog, setShowCommonDialog] = useState({isShow:false});
  const [gstSelectedOptions, setGstSelectedOptions] = useState([]);
  const [isOTPFormSubmitted, setIsOTPFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [dialogObj, setDialogObj] = useState();
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [gstFileList, setGstFileList] = useState([]);

  const [pagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");

  const [gstSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action"],
  });

  const gstColumns = useMemo(
    () => [
      {
        Header: "GSTIN",
        accessor: "entityGstn",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Status",
        accessor: "statusMsg",
        filterable: true,
        Cell: (cellProps) => {
          return startCase(cellProps.value) || "";
        },
      },
      {
        Header: "Message",
        accessor: "message",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Updated On",
        accessor: "createdAt",
        filterable: true,
        Cell: (cellProps) => {
          return dateFormat(cellProps.value || "", "DD-MM-YYYY");
        },
      },
      {
        Header: "GST Report File",
        accessor: "responseFile",
        Cell: (cellProps) => {
          return TableFileComponent(cellProps.value,!cellProps.value,()=>{downloadDocument(cellProps.value)})
        },
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(()=>{
            setDialogObj(rowData);
            setDeleteDialog(true);
      });      
        },
      },
    ],
    []
  );
  useEffect(()=>{
    const userDetails = decryptedValue(localStorage.getItem("user"));
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
  },[ entityId, encodedId])

  const validationGSTUserCredentials = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: "",
      gstin: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Username is required"),
      password:
        gstSelectedGroup?.value == "username_password"
          ? Yup.string().required("Password is required")
          : Yup.string(),
      gstin: Yup.string()
        .matches(API_SERVICES.GSTN_PATTERN, "Enter valid GSTN pattern")
        .required("GSTN is required"),
    }),
    onSubmit: (values) => {
      if (gstSelectedGroup?.value == "username_password"){
        setShowCommonDialog({isShow:true,data:{type:'gstin_user'},message:'Are you sure want to submit GSTIN?'})
      }
      else{ 
        setShowCommonDialog({isShow:true,data:{type:'gstin_otp'},message:'Are you sure want to submit GSTIN?'})
  
      }
    },
  });

  const validationGSTOTP = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: "",
      otp: "",
      gstin: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Username is required"),
      otp: Yup.string().required("OTP is required"),
      gstin: Yup.string()
        .matches(API_SERVICES.GSTN_PATTERN, "Enter valid GSTN pattern")
        .required("GSTN is required"),
    }),
    onSubmit: (values) => {
      submitGSTOTPValidation(validationGSTOTP.values);
     
    },
  });

  useEffect(() => {
    getDropDownList({ dropdownName: "gst" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "gst")
            ?.dropdownValues || [];
        setGstSelectedOptions(dropdownValues);
      })
      .catch((error) => {
        console.log(error);
      });
if(entityId){
  loadGSTList();
}
  }, [entityId]);

  const loadGSTList = async () => {
    const postParams = {
      entity_id: entityId,
      type: "gst",
    };

    callGSTLists(postParams)
      .then((response) => {
        if (response.code == 200 && response.status) {
          const { data } = response;
          setGstFileList(data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlePageChange = (
    page,
    pageSize,
    searchKey = searchValue,
    columnName = columnId,
    sortingOrder = sortingOrderStatus
  ) => {
    setPageSize(pageSize);
  };

  const handleSortColumn = (option) => {
    setItrSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder);
  };

  const handleSearchFilter = (value, pageSize) => {
    setSearchValue(value);
    handlePageChange(1, pageSize, value);
  };
  const handleClearSearch = () => {
    setSearchValue("");
    handlePageChange(1, pageSize, "", "id", "desc");
  };

  const submitGSTUserNamePassword = async (values) => {
    // const {entityId} = await getUser()
    setLoading(true)
    const postParams = {
      username: [values.username],
      password: [values.password],
      gstin: [values.gstin],
      entity_id: entityId,
    };

    callGSTINUserCredinatialsSubmit(postParams)
      .then((response) => {
        setLoading(false)
        if (response.code == 200 && response.status) {
          const {  message } = response;
          if(message){
            setToastInfo({ message: message, showToast: true, role: "success" });
          }else{
            setToastInfo({ message: response?.data, showToast: true, role: "error" });
          }
          validationGSTUserCredentials.resetForm();
          setGstSelectedGroup(null);
          loadGSTList();
        } else {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((error) => {
        setLoading(false)
        console.log(error);
      });
  };

  const submitGSTUserNameOTP = async (values) => {
    setLoading(true)
    const postParams = {
      username: values.username,
      gstin: values.gstin,
      entity_id: entityId,
    };

    callGSTINUserOTPSubmit(postParams)
      .then((response) => {
        setLoading(false)
        if (response.code == 200 && response.status) {
          setIsOTPFormSubmitted(true);
          validationGSTOTP.setFieldValue("username", values.username);
          validationGSTOTP.setFieldValue("gstin", values.gstin);
          validationGSTOTP.validateField();
          validationGSTUserCredentials.resetForm();
        } else {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((error) => {
        setLoading(false)
        console.log(error);
      });
  };

  const submitGSTOTPValidation = (values) => {
    setLoading(true)
    const postParams = {
      username: values.username,
      gstin: values.gstin,
      otp: values.otp,
      entity_id: entityId,
    };

    callGSTINUserOTPValidSubmit(postParams)
      .then((response) => {
        setLoading(false)
        if (response.code == 200 && response.status) {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "success" });
          setIsOTPFormSubmitted(false);
          validationGSTOTP.resetForm();
          setGstSelectedGroup(null);
        } else {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((error) => {
        setLoading(false)
        console.log(error);
      });
  };

  const deleteGSTRecord = () => {
    setDeleteDialog(false);

    const postParams = {
      id: dialogObj?.id,
    };

    callGSTDeleteRecord(postParams)
      .then((response) => {
        if (response.code == 200 && response.status) {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "success" });
          const filterRemoveData = itrFileList.filter(
            (d) => d.id != dialogObj?.id
          );
          setGstFileList(filterRemoveData);
          setDialogObj(null);
        } else {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const dialogAction = (action,data) =>{
    
    if(data.type=='gstin_user' && action==1)
    {
        setShowCommonDialog({isShow:false})
        submitGSTUserNamePassword(validationGSTUserCredentials.values);
        
    }else if(data.type=='gstin_otp' && action==1)
    {
      setShowCommonDialog({isShow:false})
      submitGSTUserNameOTP(values);
    }else {
     
        setShowCommonDialog({isShow:false})
    }
}

 

  return (
    <React.Fragment>
        <div className="row">
          <Col sm="12" md="4" className="mb-3">
            <Label>Select option to fetch GST</Label>

            <Select
              value={gstSelectedGroup}
              onChange={(e) => {
                setIsOTPFormSubmitted(false);
                setGstSelectedGroup(e);
                validationGSTUserCredentials.resetForm();
              }}
              options={gstSelectedOptions?.map((o) => {
                return { label: o.displayName, value: o.dropdownValue };
              })}
            />
          </Col>
          <Col xl="12">
            {gstSelectedGroup && !isOTPFormSubmitted && (
              <Form
                className="needs-validation"
                onSubmit={(e) => {
                  e.preventDefault();
                  validationGSTUserCredentials.handleSubmit();
                  return false;
                }}
              >
                <div className="row">
                  <Col sm="12" md="4">
                    <div className="mb-3">
                      <Label
                        htmlFor="validationGstUsername"
                        className="required-sign"
                      >
                        GST Username <i className="mdi mdi-asterisk"></i>
                      </Label>
                      <Input
                        name="username"
                        placeholder="Enter Username"
                        type="text"
                        className="form-control"
                        id="validationGstUsername"
                        onChange={validationGSTUserCredentials.handleChange}
                        onBlur={validationGSTUserCredentials.handleBlur}
                        value={
                          validationGSTUserCredentials.values.username || ""
                        }
                        invalid={
                          validationGSTUserCredentials.touched.username &&
                          validationGSTUserCredentials.errors.username
                        }
                      />

                      {validationGSTUserCredentials.touched.username &&
                      validationGSTUserCredentials.errors.username ? (
                        <FormFeedback type="invalid">
                          {validationGSTUserCredentials.errors.username}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  {gstSelectedGroup.value == "username_password" && (
                    <Col sm="12" md="4">
                      <div className="mb-3">
                        <Label
                          htmlFor="validationGstPassword"
                          className="required-sign"
                        >
                          GST Password <i className="mdi mdi-asterisk"></i>
                        </Label>
                        <Input
                          name="password"
                          placeholder="Enter Password"
                          type="password"
                          className="form-control"
                          id="validationGstPassword"
                          onChange={validationGSTUserCredentials.handleChange}
                          onBlur={validationGSTUserCredentials.handleBlur}
                          value={
                            validationGSTUserCredentials.values.password || ""
                          }
                          invalid={
                            validationGSTUserCredentials.touched.password &&
                            validationGSTUserCredentials.errors.password
                          }
                        />

                        {validationGSTUserCredentials.touched.password &&
                        validationGSTUserCredentials.errors.password ? (
                          <FormFeedback type="invalid">
                            {validationGSTUserCredentials.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  )}
                  <Col sm="12" md="4">
                    <div className="mb-3">
                      <Label
                        htmlFor="validationGstPan"
                        className="required-sign"
                      >
                        GSTIN <i className="mdi mdi-asterisk"></i>
                      </Label>
                      <Input
                        name="gstin"
                        placeholder="Enter GSTIN"
                        type="text"
                        className="form-control"
                        id="validationGstPan"
                        onChange={validationGSTUserCredentials.handleChange}
                        onBlur={validationGSTUserCredentials.handleBlur}
                        value={validationGSTUserCredentials.values.gstin || ""}
                        invalid={
                          validationGSTUserCredentials.touched.gstin &&
                          validationGSTUserCredentials.errors.gstin
                        }
                      />

                      {validationGSTUserCredentials.touched.gstin &&
                      validationGSTUserCredentials.errors.gstin ? (
                        <FormFeedback type="invalid">
                          {validationGSTUserCredentials.errors.gstin}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col xl="12" className="d-flex justify-content-center mb-4">
                    <button
                      type="submit"
                      className="btn btn-success save-customer"
                      disabled={loading}
                    >
                      {loading && (
                        <span
                          className="spinner-border spinner-border-sm ms-2 me-2"
                          aria-hidden="true"
                        ></span>
                      )}
                      {loading && <span>Saving</span>}
                      {!loading && <span>Save</span>}
                    </button>
                  </Col>
                </div>
              </Form>
            )}
            {gstSelectedGroup?.value != "username_password" &&
              isOTPFormSubmitted && (
                <Form
                  className="needs-validation"
                  onSubmit={(e) => {
                    e.preventDefault();
                    validationGSTOTP.handleSubmit()                    
                    return false;
                  }}
                >
                  <div className="row">
                    <Col sm="12" md="4">
                      <div className="mb-3">
                        <Label
                          htmlFor="validationGstOTP"
                          className="required-sign"
                        >
                          Validate OTP Sent on mobile number{" "}
                          <i className="mdi mdi-asterisk"></i>
                        </Label>
                        <Input
                          name="otp"
                          placeholder="Enter Valid OTP"
                          type="text"
                          className="form-control"
                          id="validationGstOTP"
                          onChange={validationGSTOTP.handleChange}
                          onBlur={validationGSTOTP.handleBlur}
                          value={validationGSTOTP.values.otp || ""}
                          invalid={
                            validationGSTOTP.touched.otp &&
                            validationGSTOTP.errors.otp
                          }
                        />

                        {validationGSTOTP.touched.otp &&
                        validationGSTOTP.errors.otp ? (
                          <FormFeedback type="invalid">
                            {validationGSTOTP.errors.otp}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col xl="12" className="d-flex justify-content-center mb-4">
                    <button
                        type="submit"
                        className="btn btn-success save-customer"
                        disabled={loading}
                      >
                        {loading && (
                          <span
                            className="spinner-border spinner-border-sm ms-2 me-2"
                            aria-hidden="true"
                          ></span>
                        )}
                        {loading && <span>Saving</span>}
                        {!loading && <span>Save</span>}
                      </button>
                    </Col>
                  </div>
                </Form>
              )}
          </Col>
          <hr className="hr-divider" />
          <Col xl="12">
            <div className="row">
              <TableContainerV1
                columns={gstColumns}
                data={gstFileList}
                pagination={pagination}
                handlePageChange={handlePageChange}
                handleSearchFilter={handleSearchFilter}
                sortOptions={gstSortingOptions}
                handleSortColumn={handleSortColumn}
                handleClearSearch={handleClearSearch}
                hidePageSize={true}
                hideSearchView={true}
                className="custom-header-css"
              />
            </div>
          </Col>
        </div>
        <DeleteModal
          msg="Are you sure to delete record?"
          show={deleteDialog}
          onDeleteClick={deleteGSTRecord}
          onCloseClick={() => setDeleteDialog(false)}
        />
          {showCommonDialog && 
            <CommonDialog isShow={showCommonDialog.isShow} message={showCommonDialog.message} data={showCommonDialog.data}  postitiveBtn={'Submit'} negativeBtn={'Close'}  onCloseFn={dialogAction}></CommonDialog>
        }
        <ToastDialog
          message={toastInfo.message || ""}
          showToast={toastInfo.showToast}
          role={toastInfo.role}
          onCloseFn={() => setToastInfo({ showToast: false })}
        ></ToastDialog>
    </React.Fragment>
  );
};

export default GSTDocuments;
